import React from 'react'
import { Button, Image } from 'react-bootstrap'
import { logos } from '@/utils/auth-logos'
import { OAUTH_LOGIN_PROVIDERS } from '@/components/oauth/OAuthLoginCallback.jsx'

const SignInWithSocial = ({ mode = 'login', onSocialLogin }) => {
    const isLogin = mode === 'login';

    return (
        <>
            <div
                className="d-flex position-relative align-items-center justify-content-center mt-4 mb-4"
                style={{ height: '30px' }}
            >
                <div className="flex-grow-1">
                    <hr className="mb-4 w-100 border-0 border-top border-primary" />
                </div>
                <div
                    className="w-20 text-center position-relative"
                    style={{ top: '-5px', marginLeft: '11px', left: '-5px' }}
                >
                    {isLogin ? 'or sign in with' : 'or sign up with'}
                </div>
                <div className="flex-grow-1">
                    <hr className="mb-4 w-100 border-0 border-top border-primary" />
                </div>
            </div>
            <div className="d-flex flex-column flex-sm-row position-relative align-items-center justify-content-between mb-4 gap-3 w-100">
                <Button
                    variant="secondary"
                    className="d-flex align-items-center justify-content-center flex-fill w-100 w-sm-auto rounded-2"
                    style={{ paddingTop: '2px', paddingBottom: '2px' }}
                    onClick={onSocialLogin.bind(null, OAUTH_LOGIN_PROVIDERS.facebook)}
                >
                    <Image src={logos.Facebook} alt="Facebook" className="img-fluid avatar-30 object-contain" />
                </Button>
                <Button
                    variant="secondary"
                    className="d-flex align-items-center justify-content-center flex-fill w-100 w-sm-auto rounded-2"
                    style={{ paddingTop: '2px', paddingBottom: '2px' }}
                    onClick={onSocialLogin.bind(null, OAUTH_LOGIN_PROVIDERS.google)}
                >
                    <Image src={logos.Google} alt="Google" className="img-fluid avatar-30 object-contain" />
                </Button>
                <Button
                    variant="secondary"
                    className="d-flex align-items-center justify-content-center flex-fill w-100 w-sm-auto rounded-2"
                    style={{ paddingTop: '2px', paddingBottom: '2px' }}
                    onClick={onSocialLogin.bind(null, OAUTH_LOGIN_PROVIDERS.linkedin)}
                >
                    <Image src={logos.LinkedIn} alt="LinkedIn" className="img-fluid avatar-30 object-contain" />
                </Button>
            </div>
        </>
    )
}

export default SignInWithSocial
